// extracted by mini-css-extract-plugin
module.exports = {"container":"_3ea6fa5da8--container--rxtOg","text":"_3ea6fa5da8--text--bAGvf","simplified-text":"_3ea6fa5da8--simplified-text--iiVhT","work-time":"_3ea6fa5da8--work-time--URsf3"};